<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Документ о воинской обязанности"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeMilitary"
      />
    </v-col>

    <v-col cols="12" md="4"  class="py-0">
      <v-text-field
        v-model="military.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setMilitary"
      >
        <template #label>
          <span :class="{'required': requiredIfMan}">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="4"  class="py-0">
      <v-text-field
        v-model="military.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setMilitary"
      >
        <template #label>
          <span :class="{'required': requiredIfMan}">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="4"  class="py-0">
      <DatePicker
        label="Дата выдачи"
        :required="requiredIfMan"
        :prop-date="military.issueDate"
        @set-date="setIssueDate"
      />
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл документа о воинской обязанности"
        :ref-id="military.id"
        ref-class-name="Military"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {Military} from "@/models"
import {mapState} from "vuex"

export default {
  name: "Achievement",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: Military
  },

  data: () => ({
    military: new Military()
  }),

  computed: {
    ...mapState('personalData', ['personalData']),

    requiredIfMan() {
      return this.personalData.gender?.id === 1
    },
  },

  methods: {
    setMilitary() {
      this.$emit('set-data', this.military)
    },

    removeMilitary() {
      this.$emit('remove', this.military)
    },

    setIssueDate(value) {
      this.military.issueDate = value
      this.setMilitary()
    },

    setFiles(value) {
      this.military.filesData = value
      this.setMilitary()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.military = Military.build(this.item)
      }
    }
  }
}
</script>

<style scoped>
</style>
